<template lang="pug">
div.container-fluid.animated.fadeIn
  nav(aria-label="breadcrumb")
    b-breadcrumb
      b-breadcrumb-item
        router-link(to="/report/retention")
          i.fa.fa-poll-h
          span.ml-1 {{ $t("ui.retention") }}
  div.row
    div.col-md-12
      div.card
        div.card-header
          div.row
            div.col-md-12.mb-1
              div.row
                div.col-md-3.mb-1(v-if="filterBy != 'current_month_active_user'")
                  DateRangePicker(:value="dateRange" @update="getData" ref="dateRange")
                div.col-md-4.mb-1
                    b-form-radio-group(
                      buttons
                      v-model="filterBy"
                      size="sm"
                      button-variant="outline-info"
                      @input="onChangeFilter()"
                    )
                      b-form-radio(value="signup_date") {{ $t("ui.signup_date") }}
                      b-form-radio(value="last_deposit_date") {{ $t("ui.last_deposit_date") }}
                      b-form-radio(value="current_month_active_user") {{ $t("ui.current_month_active_user") }}
                div.col-md-3.mb-1
                  SubmitButton(
                    :loading="loading"
                    icon="fa fa-search"
                    :text="$t('ui.search')"
                    type="button"
                    @click="getReportList(true)"
                    variant="success"
                    size="sm"
                    ).mr-2
                  //- jsonToExcel(v-if="reportList.length > 0" mode="UTMList" tbl="tblList" :date="dateRange")
        div.card-body
          div.mb-1
            div.row.mb-1
              div.col-md-10
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRow"
                  :per-page="getPageSize"
                  v-model="currentPage"
                  @input="changePage($event)").mb-1
              div.col-md-2
                b-input-group(:prepend="$t('ui.page_size')" size="sm").mb-1
                  b-form-select(:options="$store.getters.utmPageSizeOptions" :value="getPageSize" @input="changePageSize")
          div.row.clusterize
            div.col-md-12
              .clusterize-scroll
                table.tablex#tblList(style="width: 100%;" v-columns-resizable)
                  thead
                    tr
                      th.sticky-position(width="5%")
                        span #
                      th.sticky-position.sortable(width="10%" @click="sortOrder('account_id')")
                        span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                        i(:class="changeSortKey('account_id')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('verified_date')")
                        span(:title="$t('ui.verified_date')") {{ $t('ui.verified_date') }}
                        i(:class="changeSortKey('verified_date')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('ftd_date')")
                        span(:title="$t('ui.ftd_date')") {{ $t('ui.ftd_date') }}
                        i(:class="changeSortKey('ftd_date')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('ltd_date')")
                        span(:title="$t('ui.ltd_date')") {{ $t('ui.ltd_date') }}
                        i(:class="changeSortKey('ltd_date')")
                      th.sticky-position.sortable.text-center(width="10%" @click="sortOrder('current_month_active')")
                        span(:title="$t('ui.current_month_active')") {{ $t('ui.current_month_active') }}
                        i(:class="changeSortKey('current_month_active')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('first_month')")
                        span(:title="$t('ui.first_month')") {{ $t('ui.first_month') }}
                        i(:class="changeSortKey('first_month')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('fmwinlose')")
                        span(:title="$t('ui.fmwinlose')") {{ $t('ui.fmwinlose') }}
                        i(:class="changeSortKey('fmwinlose')")
                      th.sticky-position.sortable(width="10%" @click="sortOrder('fmdeposit_amount')")
                        span(:title="$t('ui.fmdeposit_amount')") {{ $t('ui.fmdeposit_amount') }}
                        i(:class="changeSortKey('fmdeposit_amount')")
                      th.text-center.sticky-position(width="6%")
                        span(:title="$t('ui.action')") {{ $t("ui.action") }}
                  tbody.clusterize-content
                    tr(v-if="reportList.length == 0")
                      td(:colspan="10").text-center
                        span {{ $t('message.no_data_available') }}
                    template(v-for="(item, index) in reportList")
                      tr
                        td
                          span(:title="((currentPage - 1) * getPageSize + index + 1)") {{ ((currentPage - 1) * getPageSize + index + 1) }}
                        td
                          span(:title="item.account_id") {{ item.account_id }}
                        td
                          span(:title="$moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.verified_date") {{ $moment(item.verified_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td
                          span(:title="$moment(item.ftd_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.ftd_date") {{ $moment(item.ftd_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td
                          span(:title="$moment(item.ltd_date).format('YYYY-MM-DD, HH:mm:ss')" v-if="item.ltd_date") {{ $moment(item.ltd_date).format('YYYY-MM-DD, HH:mm:ss') }}
                        td.text-center
                          span
                            i(:class="{'fas fa-check text-info': item.current_month_active, 'fas fa-times text-warning': !item.current_month_active  }")
                        td
                          span(:title="$moment(item.first_month).format('YYYY-MM-DD')" v-if="item.first_month") {{ $moment(item.first_month).format('YYYY-MM-DD') }}
                        td
                          span.font-weight-bold(:class="$helpers.fontClassName(item.fmwinlose)" :title="$n(item.fmwinlose, 'currency')") {{ $n(item.fmwinlose, 'currency') }}
                        td
                          span.font-weight-bold(:class="$helpers.fontClassName(item.fmdeposit_amount)" :title="$n(item.fmdeposit_amount, 'currency')") {{ $n(item.fmdeposit_amount, 'currency') }}
                        td.text-center
                          i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item)" :class="currId == item.account_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                      tr(v-if="isShowDetail == true && currId == item.account_id")
                        td(colspan="10")
                          table.tablex(style="width: 100%;").mb-2
                            thead
                              tr
                                template(v-for="(item1, index1) in monthOpt")
                                  th.sticky-position.sortable(width="9%")
                                    span {{ $t("ui.deposit") }} {{item1}}
                                  th.sticky-position.sortable(width="9%")
                                    span {{ $t("ui.winlose") }} {{item1}}
                            tbody.clusterize-content
                              tr
                                template(v-for="(item1, index1) in monthOpt")
                                  td
                                    span.font-weight-bold(:class="$helpers.fontClassName(item['d'+ item1])" :title="$n(item['d'+ item1], 'currency')") {{ $n(item['d'+ item1], 'currency') }}
                                  td
                                    span.font-weight-bold(:class="$helpers.fontClassName(item['wl'+ item1])" :title="$n(item['wl'+ item1], 'currency')") {{ $n(item['wl'+ item1], 'currency') }}
</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/lib/vue-daterange-picker.min.css';
import jsonToExcel from "@/library/jsonToExcel.vue";

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker,
    jsonToExcel
  },
  data: () => ({
    loading: false,
    reportList: [],
    currentPage: 1,
    totalRow: 0,
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    startDate: null,
    endDate: null,
    dateRange: {
      startDate: null,
      endDate: null
    },
    editSelectedMember: null,
    sortKey: "verified_date",
    sortType: "desc",
    filterBy: "signup_date",
    currId: null,
    isShowDetail: false,
    monthOpt: [],
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.utmPageSize;
    },
    on() {
      return this.$t("ui.on");
    },
    off() {
      return this.$t("ui.off");
    }
  },
  mounted: function() {
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.getDateOpt();
  },
  methods: {
    onChangeFilter() {
      if (this.filterBy == "current_month_active_user") {
        this.dateRange.startDate = this.$moment(new Date).startOf("month").format('YYYY-MM-DD');
        this.dateRange.endDate = this.$moment(new Date).endOf("month").format('YYYY-MM-DD');
        this.$refs.dateRange.dateRange.startDate = this.$moment(new Date).startOf("month").format('YYYY-MM-DD');
        this.$refs.dateRange.dateRange.endDate = this.$moment(new Date).endOf("month").format('YYYY-MM-DD');
      }
    },
    getDateOpt() {
      for(var i = -5; i <= 0; i++) {
        this.monthOpt.push(this.$moment(new Date).add(i, 'month').startOf("month").format('YYYY-MM-DD'));
      }
    },
    onOffDetail(item) {
      if (this.isShowDetail == true) {
        if (this.currId == item.account_id) {
          this.isShowDetail = false;
          this.currId = null;
        } else {
          this.isShowDetail = false;
          this.currId = null;
          this.isShowDetail = true;
          this.currId = item.account_id;
        }
      } else {
        this.isShowDetail = true;
        this.currId = item.account_id;
      }
    },
    sortOrder(key) {
      if (this.sortKey == key)
        this.sortType = this.sortType == 'asc' ? 'desc' : 'asc';
      else {
        this.sortKey = key;
        this.sortType = 'asc';
      }
      this.getReportList(true);
    },
    changeSortKey(key) {
      if (this.sortKey != key)
        return 'fas fa-sort';
      else if (this.sortKey == key && this.sortType == 'asc')
        return 'fa fa-sort-up';
      else if (this.sortKey == key && this.sortType == 'desc')
        return 'fa fa-sort-down';
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getReportList(true);
    },
    getFilterIndex() {
      if (this.filterBy == "signup_date")
        return 1;
      else if (this.filterBy == "last_deposit_date")
        return 2;
      else
        return 3;
    },
    clear() {
      this.reportList = [];
      this.totalRow = 0;
      this.isShowDetail = false;
      this.currId = null;
    },
    getReportList: function(isSearch) {
      if (this.checkDateRange()) {

        let url = config.retentionUrl();

        if (isSearch) this.currentPage = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          account_id: this.$store.getters.accountId,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          filter: this.getFilterIndex(),
          sort_type: this.sortType,
          sort_key: this.sortKey,
          page_number: this.currentPage,
          page_size: this.getPageSize
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clear()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  this.reportList = response.data.dt;
                  this.totalRow = this.reportList.length > 0 ? this.reportList[0].totalrows : 0;
                } else {
                  this.totalRow = 0;
                  this.reportList = [];
                  if (this.feedback.status != 'permission_denied') {
                    if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  else {
                    this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                  }
                  // if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("error.connection"), this.$t("error." + this.feedback.status), "error");
          }
        );
      }
      else {
        this.totalRow = 0;
        this.reportList = [];
        this.$helpers.showDialog(this.$t("error.connection"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    changePageSize: function(pageSize) {
      this.$store.dispatch("layout/setUTMPageSize", pageSize);
      this.currentPage = 1;
      this.getReportList(true);
    },
    changePage: function(pageNo) {
      this.currentPage = pageNo;
      this.getReportList();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>
<style lang="scss" scoped>
.text-italic {
  font-style: italic !important;
}
</style>